import { render, staticRenderFns } from "./KFieldGroup.vue?vue&type=template&id=f1c27c36&"
import script from "./KFieldGroup.vue?vue&type=script&lang=ts&"
export * from "./KFieldGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports